import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=ff05d6f2"
import script from "./Command.vue?vue&type=script&lang=js"
export * from "./Command.vue?vue&type=script&lang=js"
import style0 from "./Command.vue?vue&type=style&index=0&id=ff05d6f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports